import ServiceBase from './ServiceBase';
import store from '../store';
import PostHearingLetterRequest from '../models/PostHearingLetterRequest';
import PostHearingLetterMergeData from '../models/PostHearingLetterMergeData';

export default class HearingService extends ServiceBase {
    public GetHearingDetails(hearingID: number, username: string): Promise<any> {

        return this.post('Docketing/GetHearingDetails', { hearingId: hearingID, UserName: username })
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('dashblocks erred');
            })
    }

    public GetHearingAttorneys(): Promise<any> {

        return this.get('RefDocketing/GetHearingAttorneys')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingAttorneys erred');
            })
    }

    public GetHearingOfficers(): Promise<any> {

        return this.get('RefDocketing/GetHearingOfficers')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingOfficers erred');
            })
    }

    public GetHearingDocketTypes(): Promise<any> {

        return this.get('RefDocketing/GetHearingDocketTypes')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingDocketTypes erred');
            })
    }

    public GetHearingOutcomes(): Promise<any> {

        return this.get('RefDocketing/GetHearingOutcomes')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingOutcomes erred');
            })
    }

    public GetHearingLevels(): Promise<any> {

        return this.get('RefDocketing/GetHearingLevels')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingLevels erred');
            })
    }

    public GetHearingPendedReasons(): Promise<any> {

        return this.get('RefDocketing/GetHearingPendedReasons')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingPendedReasons erred');
            })
    }

    public GetHearingIssues(): Promise<any> {

        return this.get('RefDocketing/GetHearingIssues')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingIssues erred');
            })
    }

    public GetHearingComments(): Promise<any> {

        return this.get('RefDocketing/GetHearingComments')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingComments erred');
            })
    }

    public GetHearingLocations(): Promise<any> {

        return this.get('RefDocketing/GetHearingLocations')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingLocations erred');
            })
    }

    public GetHearingReps(): Promise<any> {

        return this.get('RefDocketing/GetHearingReps')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingReps erred');
            })
    }

    public GetTPAExternalContacts(obj: any): Promise<any> {
        return this.post('Docketing/GetTPAExternalContacts', obj)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetTPAExternalContacts erred');
            })
    }

    public GetTPAInternalContacts(obj: any): Promise<any> {
        return this.post('Docketing/GetTPAInternalContacts', obj)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetTPAInternalContacts erred');
            })
    }

    public GetCombinedContacts(obj: any): Promise<any> {
        return Promise.all([this.GetTPAExternalContacts(obj), this.GetTPAInternalContacts(obj)])
            .then((responses) => {
                let merged = [...responses[0].data, ...responses[1].data];
                return merged;
            })
    }

    public UpdateHearingDetails(data: any): Promise<any> {
        return this.put('Docketing/UpdateHearingDetails', data)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                store.dispatch('addApplicationMessages', error.message);
                console.log('UpdateHearingDetails erred');
            })
    }

    public SearchHearing(data: any): Promise<any> {
        return this.post('Docketing/SearchHearings', data)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                store.dispatch('addApplicationMessages', error.message);
                console.log("SearchHearing erred");
            })
    }

    public CreatePostHearingLetter(data: PostHearingLetterMergeData): Promise<any> {
        return this.streamFiles('Document/CreatePostHearingPDF', data)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                store.dispatch('addApplicationMessages', error.message);
                console.log("CreatePostHearingLetter erred");
            })
    }

    public GetHearingOfficerTypes(): Promise<any> {

        return this.get('RefDocketing/GetHearingOfficerTypes')
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetHearingOfficerTypes erred');
            })
    }

    public GetPostHearingLetterDataFields(req: any): Promise<any> {
        return this.post('Docketing/GetPostHearingLetterFields', req)
            .then((response) => {
                return response;
            })
            .catch(error => {
                console.log('GetPostHearingLetterDataFields erred');
            })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/services/HearingService.ts